import posthog from 'posthog-js';
import { config } from './config.js';

/**
 * Initializes the PostHog analytics library for tracking user interactions.
 */
export function initPostHog() {
  // Initialize PostHog
  posthog.init(config.postHogApiKey, {
    api_host: 'https://us.i.posthog.com',
    /**
     * Turning the below property on disables a lot of PostHog features that are not needed currently, but may be needed in the future.
     * For now, we want this off to avoid unnecessary requests to PostHog.
     * For the full list of features this property disables, see:
     * https://posthog.com/docs/libraries/js/config#resources-dependent-on-decide
     */
    advanced_disable_decide: true,
    autocapture: false,
    capture_pageview: false,
    disable_session_recording: true,
    person_profiles: 'identified_only' // or 'always' to create profiles for anonymous users as well
  });
}
